// extracted by mini-css-extract-plugin
export default {"wrapper":"privacy_wrapper__Yy0mU","title":"privacy_title__doukJ","contents":"privacy_contents__Xal61"};